import React, { Fragment } from "react";
import { LoadingMessage } from "../../Controls";
import { Row, Col } from "reactstrap";
import style from "./styles.module.scss";
import { FormField } from "../../../..";

const AssetSubClass = ({ subAsset }) => {
  return (
    <div className={style.subAsset}>
      <span className={style.sectionDark}>Sub asset class section</span>
      {subAsset ? (
        <Fragment>
          <Row>
            <Col lg="3">
              <FormField
                name="AssetClassName"
                label="Sub Asset Class Name"
                value={subAsset.SubAssetClassName}
                disabled
              />
            </Col>

            <Col lg="3">
              <FormField
                name="AssetClassName"
                label="Asset Class Name"
                value={subAsset.AssetClassName}
                disabled
              />
            </Col>

            <Col lg="3">
              <FormField name="SubAssetClassForm" label="Form" value={subAsset.SubAssetClassForm} disabled />
            </Col>
          </Row>

          <Row>
            <Col lg="3">
              <FormField
                name="SubAssetClassHasRegularPayments"
                label="Has Regular Payments"
                value={parseYesNo(subAsset.SubAssetClassHasRegularPayments)}
                disabled
              />
            </Col>

            <Col lg="3">
              <FormField
                name="SubAssetClassHasMaturity"
                label="Has Maturity"
                value={parseYesNo(subAsset.SubAssetClassHasMaturity)}
                disabled
              />
            </Col>

            <Col lg="3">
              <FormField
                name="SubAssetClassIsanOption"
                label="Is an option"
                value={parseYesNo(subAsset.SubAssetClassIsanOption)}
                disabled
              />
            </Col>

            <Col lg="3">
              <FormField
                name="SubAssetClassIsanOption"
                label="Is Fund"
                value={parseYesNo(subAsset.SubAssetClassIsanOption)}
                disabled
              />
            </Col>
          </Row>
        </Fragment>
      ) : (
        <LoadingMessage text="Retrieving sub asset class info" />
      )}
    </div>
  );
};

const parseYesNo = (value) => (value ? "Yes" : "No");

// &info.SubAssetClassQuoting = SubAssetClassQuoting
// &info.SubAssetClassPaymentType = SubAssetClassPaymentType
export default AssetSubClass;
